import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import LanguageModal from "../Common_profile_details_modals/LanguageModal/LanguageModal";

function LanguagesCard() {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");

  const [selectedLanguage, setSelectedLanguage] = useState({
    language: "",
    proficiency: "",
    read: false,
    write: false,
    speak: false,
  });

  const languages = [
    {
      language: "English",
      proficiency: "Beginner",
      read: true,
      write: true,
      speak: true,
    },
  ];

  const handleClose = () => {
    setShowModal(false);
  };

  const handleAdd = () => {
    setModalMode("add");

    setSelectedLanguage({
      language: "",
      proficiency: "",
      read: false,
      write: false,
      speak: false,
    });

    setShowModal(true);
  };

  const handleEdit = (item) => {
    setModalMode("edit");
    setSelectedLanguage(item);
    setShowModal(true);
  };

  return (
    <>
      <Card className="profile-card-pattern profile-pattern-expandable">
        <Card.Body className="profile-card-pattern__body">
          <div className="profile-card-pattern__header">
            <h2 className="profile-card-pattern__title">
              Languages
            </h2>

            <Button
              variant="link"
              className="profile-card-pattern__btn-add"
              onClick={handleAdd}
            >
              <span className="summary-card__edit-icon">
                ➕
              </span>
            </Button>
          </div>

          {languages.map((item, index) => (
            <>
            <div
              key={index}
              className="profile-pattern-block__item"
            >
              <div className="profile-pattern-block__item-header">
                <h3 className="profile-pattern-block__main-text">
                  {item.language}
                </h3>

                <Button
                  variant="link"
                  className="profile-card-pattern__btn-edit"
                  onClick={() => handleEdit(item)}
                >
                  <span className="summary-card__edit-icon">
                    ✏️
                  </span>
                </Button>
              </div>

              <p className="profile-pattern-block__sub-text">
                {item.proficiency}
              </p>
            </div>

            <hr/>
            </>
          ))}
        </Card.Body>
      </Card>

      <LanguageModal
        show={showModal}
        handleClose={handleClose}
        mode={modalMode}
        language={selectedLanguage}
      />
    </>
  );
}

export default LanguagesCard;